import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
const domainSlice = createSlice({
  name: 'recentVisit',
  initialState: [],
  reducers: {
    addRecent: (state, { payload }) => {
      if (!_.isEqual(payload, state[state.length - 1])) {
        if (state.length >= 3) {
          state.shift();
        }
        state.push(payload);
      }
    }
  }
});
export const { addRecent } = domainSlice.actions;
export default domainSlice;
